import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


// 获取原型对象上的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routerPc = [{
    path: '/',
    name: 'home_total',
    component: () =>
        import ('@/views/home_total/home_total.vue'),
    children: [{
            path: '/home',
            name: 'home',
            component: () =>
                import ('@/views/home/home.vue'),
        }, {
            path: '/aboutUs',
            name: 'aboutUs',
            component: () =>
                import ('@/views/aboutUs/aboutUs.vue'),
        },
        {
            path: '/recentTransactions',
            name: 'recentTransactions',
            component: () =>
                import ('@/views/recentTransactions/recentTransactions.vue'),
        }, {
            path: '/onlineTrading',
            name: 'onlineTrading',
            component: () =>
                import ('@/views/onlineTrading/onlineTrading.vue'),
        }, {
            path: '/investmentBanking',
            name: 'investmentBanking',
            component: () =>
                import ('@/views/investmentBanking/investmentBanking.vue'),
        }, {
            path: '/contactUs',
            name: 'contactUs',
            component: () =>
                import ('@/views/contactUs/contactUs.vue'),
        }, {
            path: '/getStartedWithUs',
            name: 'getStartedWithUs',
            component: () =>
                import ('@/views/onlineTrading/getStartedWithUs.vue'),
        }, { // 加入我们
            path: '/joinUs',
            name: 'joinUs',
            component: () =>
                import ('@/views/joinUs/joinUs.vue'),
        },
    ],
}, {
    path: '/reportsList',
    name: 'reportsList',
    component: () =>
        import ('@/views/reports_manage/reportsList.vue'),
}, { // CSI Login
    path: '/CSILogin',
    name: 'CSILogin',
    component: () =>
        import ('@/views/CSlClientPortal/CSILogin.vue'),
}, { // homePage
    path: '/homePage',
    name: 'homePage',
    component: () =>
        import ('@/views/CSlClientPortal/homePage.vue'),
    redirect: '/myEquity', // 重定向配置
    children: [{ // My Equity
        path: '/myEquity',
        name: 'myEquity',
        component: () =>
            import ('@/views/CSlClientPortal/myEquity.vue'),
    }, { // Order Entry
        path: '/orderEntry',
        name: 'orderEntry',
        component: () =>
            import ('@/views/CSlClientPortal/orderEntry.vue'),
    }, { // IPOS
        path: '/iposList',
        name: 'iposList',
        component: () =>
            import ('@/views/CSlClientPortal/IposList.vue'),
    }, { // My Info
        path: '/myInfo',
        name: 'myInfo',
        component: () =>
            import ('@/views/CSlClientPortal/myInfo.vue'),
    }, {
        path: '/stockDetail',
        name: 'stockDetail',
        component: () =>
            import ('@/views/CSlClientPortal/components/stockDetail.vue'),
    }, {
        path: '/buyConfirm',
        name: 'buyConfirm',
        component: () =>
            import ('@/views/CSlClientPortal/components/buyConfirm.vue'),
    }, { // 成功认购 详情
        path: '/subscriptionDetail',
        name: 'subscriptionDetail',
        component: () =>
            import ('@/views/CSlClientPortal/components/subscriptionDetail.vue'),
    }, { // 认购列表
        path: '/subscriptionRecord',
        name: 'subscriptionRecord',
        component: () =>
            import ('@/views/CSlClientPortal/components/subscriptionRecord.vue'),
    }]
}, ]

const routerM = [{
        path: '/',
        name: 'HomeMobile',
        component: () =>
            import ('@/views/HomeMobile/HomeMobile.vue'),
    },
    { path: '/home', redirect: '/', },
    { path: '/aboutUs', redirect: '/', },
    { path: '/recentTransactions', redirect: '/', },
    { path: '/onlineTrading', redirect: '/', },
    { path: '/investmentBanking', redirect: '/', },
    { path: '/contactUs', redirect: '/', },
    { path: '/getStartedWithUs', redirect: '/', },
    { path: '/reportsList', redirect: '/', },
]

var routes = []
let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
if (flag == null) {
    console.log("pc端");
    routes = routerPc
} else {
    console.log("移动端");
    routes = routerM
}

const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

//  路由判断登录 根据路由配置文件的参数
// router.beforeEach((to, from, next) => {
//     // to 将要访问的路径
//     // from  从哪个路径跳转过来的
//     // next 是一个函数,代表放行
//     let token = sessionStorage.getItem('token');
//     if (to.path === '/') {
//         return next()
//     } else {
//         if (!token) {
//             return next('/')
//         } else {
//             next()
//         }
//     }
// })

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js